module.exports = __webpack_public_path__ + "static/security-8d0bf5e1bf7f925eacf86fb2c222d1cf.svg";